/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrameworkRadarAxisDto
 */
export interface FrameworkRadarAxisDto {
    /**
     * 
     * @type {string}
     * @memberof FrameworkRadarAxisDto
     */
    functionCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FrameworkRadarAxisDto
     */
    functionName?: string;
    /**
     * 
     * @type {number}
     * @memberof FrameworkRadarAxisDto
     */
    averageMaturity?: number;
    /**
     * 
     * @type {string}
     * @memberof FrameworkRadarAxisDto
     */
    dominantDataSource?: string;
    /**
     * 
     * @type {number}
     * @memberof FrameworkRadarAxisDto
     */
    examinedControlCount?: number;
    /**
     * 
     * @type {number}
     * @memberof FrameworkRadarAxisDto
     */
    approximateTotalForFunction?: number;
    /**
     * 
     * @type {number}
     * @memberof FrameworkRadarAxisDto
     */
    unexaminedCount?: number;
}

/**
 * Check if a given object implements the FrameworkRadarAxisDto interface.
 */
export function instanceOfFrameworkRadarAxisDto(value: object): value is FrameworkRadarAxisDto {
    return true;
}

export function FrameworkRadarAxisDtoFromJSON(json: any): FrameworkRadarAxisDto {
    return FrameworkRadarAxisDtoFromJSONTyped(json, false);
}

export function FrameworkRadarAxisDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrameworkRadarAxisDto {
    if (json == null) {
        return json;
    }
    return {
        
        'functionCode': json['functionCode'] == null ? undefined : json['functionCode'],
        'functionName': json['functionName'] == null ? undefined : json['functionName'],
        'averageMaturity': json['averageMaturity'] == null ? undefined : json['averageMaturity'],
        'dominantDataSource': json['dominantDataSource'] == null ? undefined : json['dominantDataSource'],
        'examinedControlCount': json['examinedControlCount'] == null ? undefined : json['examinedControlCount'],
        'approximateTotalForFunction': json['approximateTotalForFunction'] == null ? undefined : json['approximateTotalForFunction'],
        'unexaminedCount': json['unexaminedCount'] == null ? undefined : json['unexaminedCount'],
    };
}

export function FrameworkRadarAxisDtoToJSON(json: any): FrameworkRadarAxisDto {
    return FrameworkRadarAxisDtoToJSONTyped(json, false);
}

export function FrameworkRadarAxisDtoToJSONTyped(value?: FrameworkRadarAxisDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'functionCode': value['functionCode'],
        'functionName': value['functionName'],
        'averageMaturity': value['averageMaturity'],
        'dominantDataSource': value['dominantDataSource'],
        'examinedControlCount': value['examinedControlCount'],
        'approximateTotalForFunction': value['approximateTotalForFunction'],
        'unexaminedCount': value['unexaminedCount'],
    };
}

